package com.appcreator.blueprint.core.properties

import com.appcreator.blueprint.core.Component
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonElement

@Serializable
data class ComponentReference(
    val id: String,
    val propertyValues: Map<String, JsonElement>? = null,
    val injected: ComponentResult? = null
)

@Serializable
data class ComponentProperty(
    val name: String,
    val description: String,
    val type: PropertyType,
) {
    enum class PropertyType {
        Text,
        Component
    }
}

@Serializable
data class ComponentResult(
    val properties: List<ComponentProperty>,
    val component: Component,
)